import React from 'react';
const IconNavMenuAlt = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 5H4V7H20V5Z" fill="#2D2E2E"/>
<path d="M4 14.4299L20 11.5999V9.56995L4 12.3999V14.4299Z" fill="#2D2E2E"/>
<path d="M20 17H4V19H20V17Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavMenuAlt;